import { readFragment, ResultOf } from "gql.tada";
import { StillWatchingTitleSectionById } from "@queries/entries/StillWatchingTitleSectionById";
import { useScroll, useTransform } from "motion/react";
import { useRef } from "react";
import { AnimatedSplitLines } from "@components/shared/AnimatedSplitLines";
import { StillWatchingTitleSectionFragment } from "@queries/fragments/StillWatchingTitleSectionFragment";
import { MarkdownLite } from "@components/shared/MarkdownLite";

export const StillWatchingTitleSection = ({
  entry: { titleSection: stillWatchingTitleSection },
}: {
  entry: ResultOf<typeof StillWatchingTitleSectionById>;
}) => {
  const entry = readFragment(StillWatchingTitleSectionFragment, stillWatchingTitleSection);
  const sectionRef = useRef<HTMLElement>(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });
  const titleSplitLinesMv = useTransform(
    scrollYProgress,
    [0, 0.4, 0.6, 1],
    [1, 0, 0, 0]
  );

  if (!entry) return null;

  return (
    entry.title && (
      <section
        ref={sectionRef}
        className="flex flex-col justify-center gap-5 dsk:gap-16 text-center text-balance dsk:px-20 py-32"
      >
        <h3 className="text-heading-2 text-center text-brand-cream">
          <AnimatedSplitLines key={entry._id} value={titleSplitLinesMv}>
            <MarkdownLite>{entry.title}</MarkdownLite>
          </AnimatedSplitLines>
        </h3>
      </section>
    )
  );
};
